import type { LucideIcon } from "lucide-react";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const fabClassName =
  "fixed bottom-[max(1rem,env(safe-area-inset-bottom))] right-4 z-40 flex h-11 w-11 items-center justify-center rounded-xl bg-[#9333F5] text-white shadow-md shadow-primary/20 transition-transform hover:scale-105 active:scale-95 sm:hidden";

type MobileFabProps =
  | {
      icon?: LucideIcon;
      label: string;
      className?: string;
      onClick: () => void;
      to?: undefined;
    }
  | {
      icon?: LucideIcon;
      label: string;
      className?: string;
      to: string;
      onClick?: undefined;
    };

export function MobileFab(props: MobileFabProps) {
  const { icon: Icon = Plus, label, className } = props;

  if (props.to) {
    return (
      <Link
        to={props.to}
        aria-label={label}
        title={label}
        className={cn(fabClassName, className)}
      >
        <Icon className="h-5 w-5" />
      </Link>
    );
  }

  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={props.onClick}
      className={cn(fabClassName, className)}
    >
      <Icon className="h-5 w-5" />
    </button>
  );
}
